import React, { useState } from "react";
import { Box, Button, IconButton, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PhoneIcon from "@mui/icons-material/Phone";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SendIcon from "@mui/icons-material/Send";
import theme from "../../../utils/theme";

export default function ChatsModal({ open, onClose }) {
  if (!open) return null;

  const chats = [
    {
      id: 1,
      name: "Meera Subramaniam",
      unread: 1,
      avatar: "https://i.pravatar.cc/40?img=1",
    },
    {
      id: 2,
      name: "Rahul Chandrasekar",
      unread: 1,
      avatar: "https://i.pravatar.cc/40?img=2",
    },
    {
      id: 3,
      name: "Karthik Suresh",
      unread: 0,
      avatar: "https://i.pravatar.cc/40?img=3",
    },
    {
      id: 4,
      name: "Shreya Narayanan",
      unread: 0,
      avatar: "https://i.pravatar.cc/40?img=4",
    },
  ];

  const messages = [
    {
      sender: "me",
      text: "Can I select a specific part in the layout before paying?",
      time: "8:00 PM",
    },
    {
      sender: "admin",
      text: "Of course! After verification, you can choose your preferred plot part.",
      time: "8:00 PM",
    },
    {
      sender: "me",
      text: "Can I refer my friend to join this same scheme?",
      time: "8:00 PM",
    },
    {
      sender: "admin",
      text: "Yes! Add your friend's details and both of you can join the same scheme.",
      time: "8:00 PM",
    },
  ];

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.4)",
        backdropFilter: "blur(4px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
        zIndex: 2000,
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "1200px",
          height: "85vh",
          bgcolor: "#fff",
          borderRadius: "16px",
          display: "grid",
          gridTemplateColumns: "300px 1fr",
          overflow: "hidden",
        }}
      >
        {/* LEFT SIDEBAR */}
        <Box
          sx={{
            borderRight: "1px solid #ddd",
            p: 2,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <TextField size="small" fullWidth placeholder="Search for chat" />

          <Box sx={{ mt: 2, fontSize: 12, fontWeight: 600, color: "gray" }}>
            CHAT +
          </Box>

          <Box sx={{ mt: 2, overflowY: "auto", flex: 1 }}>
            {chats.map((c) => (
              <Box
                key={c.id}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  p: 1.5,
                  borderRadius: "12px",
                  cursor: "pointer",
                  "&:hover": { bgcolor: "#f5f5f5" },
                }}
              >
                <img
                  src={c.avatar}
                  alt=""
                  style={{ width: 40, height: 40, borderRadius: "50%" }}
                />
                <Box sx={{ flex: 1, fontSize: 14, fontWeight: 600 }}>
                  {c.name}
                </Box>
                {c.unread > 0 && (
                  <Box
                    sx={{
                      bgcolor: theme.palette.primary.main,
                      color: "white",
                      width: 24,
                      height: 24,
                      fontSize: 12,
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {c.unread}
                  </Box>
                )}
              </Box>
            ))}
          </Box>
        </Box>

        {/* RIGHT SIDE */}
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          {/* HEADER */}
          <Box
            sx={{
              p: 2,
              borderBottom: "1px solid #ddd",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <img
                src="https://i.pravatar.cc/40?img=5"
                alt=""
                style={{ width: 40, height: 40, borderRadius: "50%" }}
              />
              <Box sx={{ fontSize: 16, fontWeight: 700 }}>Vijay</Box>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <IconButton>
                <PhoneIcon />
              </IconButton>
              <IconButton>
                <MoreVertIcon />
              </IconButton>
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>

          {/* MESSAGES */}
          <Box
            sx={{
              flex: 1,
              p: 3,
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              gap: 3,
            }}
          >
            {messages.map((msg, i) => (
              <Box key={i} sx={{ display: "flex", flexDirection: "column" }}>
                {msg.sender === "me" ? (
                  <Box
                    sx={{
                      alignSelf: "flex-start",
                      bgcolor: theme.palette.primary.light,
                      // bgcolor: "#e6f8e8",
                      border: "1px solid #7fcf9a",
                      px: 2,
                      py: 1,
                      borderRadius: "12px",
                      maxWidth: "60%",
                    }}
                  >
                    {msg.text}
                  </Box>
                ) : (
                  <Box
                    sx={{
                      alignSelf: "flex-end",
                      bgcolor: theme.palette.primary.dark,
                      color: "white",
                      px: 2,
                      py: 1,
                      borderRadius: "12px",
                      maxWidth: "60%",
                      display: "flex",
                      gap: 1.5,
                    }}
                  >
                    <img
                      src="https://i.pravatar.cc/35?img=5"
                      alt=""
                      style={{ width: 32, height: 32, borderRadius: "50%" }}
                    />
                    {msg.text}
                  </Box>
                )}

                <Box
                  sx={{
                    fontSize: 10,
                    color: "gray",
                    alignSelf: "flex-end",
                    mt: 0.5,
                  }}
                >
                  {msg.time}
                </Box>
              </Box>
            ))}
          </Box>

          {/* FOOTER */}
          <Box
            sx={{ p: 2, borderTop: "1px solid #ddd", display: "flex", gap: 2 }}
          >
            <TextField fullWidth size="small" placeholder="Message" />
            <Button variant="contained">
              <SendIcon />
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
